/// <reference path="./dompurify.d.ts" />
// dompurify'ın 2.x sürümünde resmi tip tanımı yok; app tsconfig'leri libs altındaki .d.ts'leri
// include etmediği için tanım triple-slash reference ile derlemeye dahil ediliyor (bkz. qz-tray-print.service.ts).
import DOMPurify from 'dompurify';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Kullanıcının HTML editörüyle girdiği içeriği (duyuru metni, açıklama vb.) güvenli hale getirir.
 * Angular'ın kendi sanitizer'ı inline `style` niteliklerini de sildiği için biçimlendirme kaybolur;
 * DOMPurify script, olay nitelikleri (onerror vb.) ve javascript: bağlantılarını temizleyip stili korur.
 * bypassSecurityTrustHtml'e yalnızca bu fonksiyondan geçmiş içerik verilmeli.
 */
export function sanitizeHtml(sanitizer: DomSanitizer, html: string | null | undefined): SafeHtml {
  const clean = DOMPurify.sanitize(html || '', { USE_PROFILES: { html: true } });
  return sanitizer.bypassSecurityTrustHtml(clean);
}
